module.exports = __webpack_public_path__ + "static/media/cinecruise-4.3f0bedbd.jpg";